import { css } from 'styled-components'

// The sign up's own fields (birthdate row, gender select, PRM and terms checkboxes), shared by the
// sign up pages and the guest prompt.
export const signUpFields = css`
  .birthdate-row {
    display: flex;
    flex-direction: row;
    gap: 15px;

    > div {
      flex: 1;
    }
  }

  .select {
    margin-bottom: 35px;
    font-size: 15px;
  }

  .field-error {
    margin: -25px 0 35px;
    font-size: 12px;
    line-height: 1.4;

    .error {
      color: ${ ({ theme }) => theme.colors.red };
    }
  }

  .prm-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-bottom: 35px;
    cursor: pointer;

    img {
      width: 25px;
      height: 25px;
    }

    span {
      font-size: 15px;
    }
  }

  /* The legal paragraph on the last step: a framed, scrollable box so the card keeps its height. */
  .terms-text {
    max-height: 260px;
    margin-bottom: 24px;
    padding: 12px 16px;
    overflow-y: auto;
    border: 2px solid ${ ({ theme }) => theme.colors.primary };
    border-radius: 8px;
    font-size: 15px;
    line-height: 1.5;
    white-space: pre-line;
    color: ${ ({ theme }) => theme.colors.black };

    .link {
      color: ${ ({ theme }) => theme.colors.primary };
      text-decoration: underline;
      cursor: pointer;
    }
  }

  /* Checkbox and a sentence that wraps to two lines, the box centred on it as on the app. */
  .checkbox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

    img {
      flex-shrink: 0;
      width: 25px;
      height: 25px;
      cursor: pointer;
    }

    span {
      flex: 1;
      font-size: 15px;
      font-weight: 500;
      line-height: 1.4;
      color: ${ ({ theme }) => theme.colors.black };
    }

    .link {
      color: ${ ({ theme }) => theme.colors.primary };
      font-weight: 700;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`
